/* eslint-disable camelcase */
<template >
  <div v-role="'func'">
    <div>
      <div class="formPosition">
        <v-card style="margin: auto; border: 1px solid #006699" width="1200">
          <v-container style="background-color: #006699; color: white">
            <div>
              <span>Editar Catálogo</span>
              <v-icon v-if="$store.state.fromStock" @click="$router.push('Novo-Stock')"
                style="float: right; color: white">arrow_back
              </v-icon>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" style="float: right; color: white">info
                  </v-icon>
                </template>
                <span>Clique aqui para saber como criar um novo Produto</span>
              </v-tooltip>
            </div>
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-container>

          <!-- ====================================================== DIALOGO INFORMATIVO ==================================================== -->
          <!-- ======================== MODAL - ADD NOVO PREÇO ============================================= -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Novo Preço</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="editedItem.precoVenda" v-money="money" @keyup="ObterPrecoDescricao()"
                              :rules="[ruleTextRequired]" label="Preço de Venda"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.margem" :rules="ruleNumberNObrigatorio"
                              label="Margem( % )"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.descricaoPreco" :disabled="true"
                              label="Preço por compreensão"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select v-if="regime_id !== '2' && regime_id !== '3'" :items="taxa_iva"
                              v-model="editedItem.iva" item-value="percentagem" item-text="descricao"
                              @change="SelecionaIvaPreco()" filled label="IVA( % )*"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select :items="descricao_isencao_ivaprecoFiltered" v-model="editedItem.isencao"
                              item-text="descricao" :disabled="disabilita_ivaPreco" filled
                              label="Motivo de isenção*"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field :rule="ruleNumber" :disabled="true" v-model="precoComIva"
                              label="Preço com IVA"></v-text-field>
                            <v-switch v-model="predifinido" label="Predefinido"></v-switch>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color: white" color="green darken-1" :disabled="!valid"
                      @click="savePreco()">Guardar</v-btn>
                    <v-btn @click="dialog = false">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ==========================================FIM DO MODAL NOVO PRECO ============================================ -->
          <!-- ======================== MODAL - ADD NOVO PREÇO ============================================================== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogTaxa" persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Novo Taxa</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="10">
                          <v-select :items="items" :disabled="true" filled label="Taxa"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-btn :disabled="true" small fab dark color="indigo">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" md="10">
                          <v-select :items="items" filled label="Descrição"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-btn small fab dark color="indigo">
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field :disabled="true" label="Código"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field :disabled="true" label="Valor"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-switch label="Sujeito a IVA"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="8"></v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-switch label="Isento a IVA"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6" md="8">
                          <v-select :items="items" :disabled="true" filled label="Não Definido"></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color: white" color="green darken-1" @click="dialogTaxa = false">Guardar</v-btn>
                    <v-btn @click="dialogTaxa = false">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ==========================================FIM DO MODAL ========================================= -->
          <!-- ======================== MODAL - ADD NOVO GRUPO-FAMILIA ======================================== -->
          <template>
            <v-row justify="center">
              <v-dialog v-model="dialogGrupo" persistent max-width="800px">
                <v-form ref="formg" v-model="validg" lazy-validation>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Novo Grupo/Familia</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="9">
                            <v-text-field v-model="editeItemGrupo.codigo" :rules="ruleRequired" :disabled="!personalizar"
                              label="Código"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-switch v-model="personalizar" label="Personalizar"></v-switch>
                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="editeItemGrupo.descricao" :rules="ruleRequired"
                              label="Nome"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color: white" color="green darken-1" :disabled="!validg"
                        @click="SaveGrupo()">Guardar</v-btn>
                      <v-btn @click="dialogGrupo = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>
          </template>
          <!-- ==========================================FIM DO MODAL ========================================= -->

          <v-row>
            <v-col cols="12" sm="6" md="1"></v-col>
            <v-col cols="12" sm="6" md="8">
              <label>{{ negocio === "Escola" ? "Emolumento Selecionado" : "Produto Selecionado" }}
                <span style="color: red; font-weight: bold">*</span>
              </label>
              <v-text-field outlined v-if="negocio !== 'Escola'" :rules="ruleRequired" v-model="descricaoProduto"
                label="Nome do Produto"></v-text-field>
              <v-combobox :readonly="true" v-else :items="emolumentos" item-text="descricao" :rules="ruleRequired"
                v-model="editedItem.emolumento" label="" @change="SelecionaEmolumento()" filled outlined
                return-object></v-combobox>
            </v-col>
            <v-col md="2"> </v-col>
          </v-row>
          <v-tabs v-model="tab" background-color="#006699" dark color="white">
            <v-tab v-for="item in items" :key="item.tab"
              :disabled="((item.id === 1 || item.id === 3) && !valid) || ((item.id === 1 || item.id === 3) && !valid1)"
              @click="TabIndexToZero(item.id)">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <!-- <v-alert
          v-model="alert"
          dismissible
          :type="alertType"
          border="left"
          :icon="iconAlert"
          transition="scale-transition"
          :style="colorAlert"
          elevation="2"
          colored-border
        >
        {{msgAlert}}
      </v-alert> -->
          <v-tabs-items v-model="tab">
            <v-form ref="form" v-model="valid" lazy-validation>
              <!-- ================ PRIMEIRO TAB 1  GERAL ============ ======================================= -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-container>
                      <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                        {{ $store.state.textMessage }}
                      </div>
                      <table style="width: 100%">
                        <tr>
                          <td style="width: 70%">
                            <v-row>
                              <v-col cols="12" sm="6" md="6">
                                <v-select :items="tipoProdutos" item-text="descricao" item-value="pkTipoProduto"
                                  :rules="ruleRequired" v-model="editedItem.tipoProduto" label="Tipo de Produto"
                                  @change="SelecionaTipoServico()" filled outlined></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-select v-model="editedItem.mercadoria" :items="mercadoriasFiltered"
                                  :disabled="mercadoria_disable || isServicoSelected"
                                  :rules="!isServicoSelected ? ruleRequired : ''" item-value="pkMercadoria"
                                  item-text="mercadoria" label="Mercadoria" filled outlined></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field outlined v-model="editedItem.codigoBarra" :disabled="isServicoSelected"
                                  @blur="VerificaCodigoExistente()" :rules="!isServicoSelected ? ruleNumber : ''"
                                  label="Código de barra"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-select :items="armazem" v-model="editedItem.armazem"
                                  :rules="!isServicoSelected ? ruleRequired : ''" item-value="pkArmazem"
                                  :disabled="isServicoSelected" item-text="descricao" label="Armazém ou Loja disponível"
                                  filled outlined></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-text-field outlined :rules="ruleRequired" :disabled="negocio === 'Escola'"
                                  v-model="editedItem.descricaoReduzida" label="Descrição reduzida"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="6">
                                <v-select :items="especificacao" v-model="editedItem.especificacaoProduto" :rules="!isServicoSelected ? ruleRequired : ''
                                  " :disabled="isServicoSelected" item-value="pkArmazem" item-text="descricao"
                                  label="Especificação do Produto" @change="SelecionaEspecProduto()" filled
                                  outlined></v-select>
                              </v-col>
                            </v-row>
                            <span style="font-size: 20px; font-weight: bold">Família/Stock</span>
                            <div style="border: 1px solid black">
                              <v-row>
                                <v-col cols="12" sm="6" md="3">
                                  <v-select v-model="editedItem.familia" item-value="pkFamiliaProduto"
                                    :items="familiaProduto" :rules="!isServicoSelected ? ruleRequired : ''
                                      " :disabled="isServicoSelected" item-text="descricao" label="Familia" filled
                                    outlined></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="1">
                                  <v-btn @click="showDialogGrupo()" class="btn_add_align" small fab dark color="indigo">
                                    <v-icon dark>add</v-icon>
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-select v-model="editedItem.controleStock" item-value="id" :items="controleStock"
                                        :disabled="isServicoSelected" :rules="!isServicoSelected ? ruleRequired : ''
                                          " item-text="descricao" label="Controle de Stock" filled outlined
                                        @change="SelecionaControleStock()" v-bind="attrs" v-on="on"></v-select>
                                    </template>
                                    <span>Define o valor para receber um alerta de
                                      baixa de stock</span>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field v-bind="attrs" v-on="on" outlined :disabled="disabledStocksFields"
                                        :rules="editedItem.controleStock === 1 ||
                                            isServicoSelected
                                            ? ''
                                            : ruleNumber
                                          " v-model="editedItem.stock_min" label="Stock Mínimo"></v-text-field>
                                    </template>
                                    <span>Define o valor para receber um alerta de
                                      baixa de stock</span>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="12" sm="6" md="2">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field outlined :disabled="disabledStocksFields" v-bind="attrs" v-on="on"
                                        :rules="editedItem.controleStock === 1 ||
                                            isServicoSelected
                                            ? ''
                                            : ruleNumber
                                          " v-model="editedItem.stock_max" label="Stock Máximo"></v-text-field>
                                    </template>
                                    <span>Define o valor para receber um alerta de
                                      excesso de stock</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </div>
                          </td>

                          <td>
                            <table style="width: 100%">
                              <tr>
                                <td style="width: 95%">
                                  <div style="
                                      border: 1px solid black;
                                      width: 250px;
                                      height: 170px;
                                      margin-left: 26px;
                                    ">
                                    <v-img style="width: 250px; height: 250px" :src="imageData"
                                      aspect-ratio="1.7"></v-img>
                                  </div>
                                </td>
                                <td>
                                  <input @change="previewImage" type="file" ref="file" style="display: none" />
                                  <v-btn @click="$refs.file.click()" class="mx-2 btn_space" small fab dark
                                    color="primary">
                                    <v-icon dark>add_a_photo</v-icon>
                                  </v-btn>
                                  <v-btn @click="imageData = ''" class="mx-2 btn_space" small fab dark color="primary">
                                    <v-icon dark>remove</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </table>
                            <v-card-actions style="margin-top: 210px; margin-left: 50px">
                              <v-btn style="color: white" color="green darken-1"
                                :disabled="!valid || codigoRepetido || descricaoProduto === null"
                                @click="Continuar()">Continuar</v-btn>
                              <v-btn @click="$router.push('consultar-emolumentos')">Cancelar</v-btn>
                            </v-card-actions>
                          </td>
                        </tr>
                      </table>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-form>
            <!-- ================ FIM - SEGUNDO TAB e Inicio 2 Tab ======================================= -->
            <v-tab-item>
              <v-card flat>
                <v-form ref="form1" v-model="valid1" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-select :items="DefinirPrecoVenda" v-model="editedItem.precoVendaDefinido"
                            item-text="descricao" item-value="id" label="Definir Preço de venda"
                            @change="SelecionaDefinirPrecoVenda()" filled outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select :items="Unidades" v-model="editedItem.unidade" item-text="descricao" item-value="id"
                            label="Definir preço por:" @click="SelecionaUnidade()" return-object filled
                            outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco">
                          <v-select :items="TipoPrecoVenda" v-model="editedItem.calculoPrecoVenda" item-text="descricao"
                            :disabled="disabledPrecoFields" item-value="id" label="Calculo do Preço de venda"
                            @change="CalculoPrecoVenda()" filled outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" v-if="!disableMargem">
                          <v-text-field outlined v-model="custoCompra" :disabled="disableMargem || disabledPrecoFields"
                            v-money="money" :rules="ruleTextRequired" label="Custo do Produto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="2" v-if="!disableMargem">
                          <v-text-field outlined v-model="margemPrecoAutomatico" @blur="CalculoPrecoVendaAutomatico()"
                            :disabled="disableMargem || disabledPrecoFields" :rules="ruleNumberNObrigatorio"
                            label="Margem(%)de Lucro"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="disableMargem && showFieldPreco">
                          <v-text-field outlined v-model="editedItem.margem"
                            :disabled="disableMargem || disabledPrecoFields" :rules="!Precoautomatico ? '' : ruleNumberNObrigatorio
                              " label="Margem( % )"></v-text-field>
                        </v-col>
                       
                        <v-col cols="12" sm="4" md="4">
                          <v-select v-if="regime_id !== '2' && regime_id !== '3'" :items="taxa_iva"
                            v-model="editedItem.iva" item-value="percentagem" item-text="descricao"
                            @change="SelecionaIvaPreco()" filled outlined label="IVA( % )*"></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-select v-if="regime_id !== '2' && regime_id !== '3'"
                            :items="descricao_isencao_ivaprecoFiltered" v-model="editedItem.isencao" item-text="descricao"
                            :rules="disabilita_ivaPreco ? ruleEmpty : ruleRequired
                              " :disabled="disabilita_ivaPreco" filled outlined return-object
                            label="Motivo de isenção*"></v-select>
                        </v-col>

                        <!-- DEFINIR O TIPO DE PREÇO POR PERÍODO -->
                        <v-col cols="12" sm="6" md="8">
                          <v-select :items="definirPrecoPeriodo" v-model="definirPrecoPeriodoSelected" item-text="descricao"
                            item-value="id" label="Preço por período" @change="SelecionaDefinirPrecoPeriodo()" filled
                            outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4"></v-col>
                        <!-- FIM DEFINIR O TIPO DE PREÇO POR PERÍODO -->

                        <!-- PREÇO ÚNICO POR PERÍODO -->
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoUnico">
                          <v-text-field outlined v-model="precoSemIva" :disabled="!disableMargem || disabledPrecoFields"
                             @keyup="ObterPrecoDescricao()" :rules="rulePrecoVenda"
                            label="Preço de Venda"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoUnico">
                          <v-text-field outlined v-model="valorDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <!-- FIM PREÇO ÚNICO POR PERÍODO -->

                        <!-- DIFERENTES PREÇOS POR PERÍODO -->
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoDiferente">
                          <v-text-field outlined v-model="precoManha" :disabled="!disableMargem || disabledPrecoFields"
                            @keyup="ObterPrecoDescricaoManha()" :rules="rulePrecoVenda"
                            label="Preço Período da manhã"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente">
                          <v-text-field outlined v-model="precoManhaDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente"></v-col>
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoDiferente">
                          <v-text-field outlined v-model="precoTarde" :disabled="!disableMargem || disabledPrecoFields"
                            @keyup="ObterPrecoDescricaoTarde()" :rules="rulePrecoVenda"
                            label="Preço Período da tarde"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente">
                          <v-text-field outlined v-model="precoTardeDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente"></v-col>
                        <v-col cols="12" sm="6" md="4" v-if="(disableMargem && showFieldPreco) && isPrecoDiferente">
                          <v-text-field outlined v-model="precoNoite" :disabled="!disableMargem || disabledPrecoFields"
                            @keyup="ObterPrecoDescricaoNoite()" :rules="rulePrecoVenda"
                            label="Preço Período da noite"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="showFieldPreco && isPrecoDiferente">
                          <v-text-field outlined v-model="precoNoiteDescricao"
                            :rules="(DefinirPrecoVendaSelected === 1) ? 1 : ruleRequired" :disabled="true"
                            label="Preço por compreensão"></v-text-field>
                        </v-col>
                        <!-- FIM DIFERENTES PREÇOS POR PERÍODO-->
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn style="color: white" color="green darken-1" :disabled="!valid1 || !valid"
                    @click="Continuar2()">Continuar</v-btn>
                  <v-btn @click="tab = 0">Voltar</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-form ref="form2" v-model="valid2" lazy-validation>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="negocio !== 'Escola'">
                          <v-select :items="DefinirPrecoVenda" v-model="definirSubstituto" item-text="descricao"
                            item-value="id" label="Definir produto substituto?" outlined filled></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="8" v-if="definirSubstituto === 2">
                          <v-combobox v-model="produtoSubstitutoModel" :items="produtosSubstitutos" outlined filled
                            hide-selected item-text="produto" label="Selecione o(s) produto(s) substituto(s)" multiple
                            return-object @click="CarregaProdutos()">
                          </v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-combobox v-if="this.negocio === 'Escola'" v-model="editedItem.curso" :rules="ruleRequired"
                            outlined filled item-value="idCurso" item-text="descricao" :items="cursos"
                            @change="loadclasse()" chips label="Selecione o Curso"></v-combobox>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-combobox v-if="this.negocio === 'Escola'" v-model="editedItem.classe" :rules="ruleRequired"
                            item-value="pkAnoacademico" item-text="descricao" :items="classesFiltered" chips
                            label="Selecione o anoacadêmico" return-object outlined filled></v-combobox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn style="color: white" color="green darken-1" :disabled="!valid1 || !valid || !valid2"
                    @click="saveProduto()">Submeter</v-btn>
                  <v-btn @click="tab = 1">Voltar</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <!-- ================ FIM - PREÇOS ======================================= -->
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axios from "../../plugins/axios";
import axiosFinancas from "../../plugins/axiosFinancas";
import { mask } from "vue-the-mask";
import { VMoney } from "v-money";
import utilitarios from "../../plugins/utilitarios";
import Swal from "sweetalert2";
const numero = require("numero-por-extenso");
const ls = require("local-storage");
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    definirPrecoPeriodo: [
      {id: 1, descricao: 'Mesmo valor por período'},
      {id:2, descricao: 'Diferentes valores por períodos'}
    ],
    definirPrecoPeriodoSelected: null,
    isPrecoUnico: false,
    precoManha: null,
    precoTarde: null,
    precoNoite: null,
    precoManhaDescricao: '',
    precoTardeDescricao: '',
    precoNoiteDescricao: '',
    valorDescricao: '',
    isPrecoDiferente: false,
    utilitarios: utilitarios,
    price: 0,
    dialogInformativo: false,
    money: {
      decimal: ",",
      thousands: ".",
      suffix: " Kz",
      precision: 2,
      masked: false,
    },
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    tab: null,
    items: [
      { tab: "Geral", disabilita: false, content: "Tab 1 Content", id: 0 },
      { tab: "Preços", disabilita: false, content: "Tab 2 Content", id: 1 },
      {
        tab: "Configurações adicionais",
        disabilita: false,
        content: "Tab 2 Content",
        id: 3,
      },
    ],
    msgAlert: "",
    alert: false,
    colorAlert: "red",
    iconAlert: "done",
    alertType: "success",
    valor: "",
    custoCompra: "",
    overlay: false,
    Precoautomatico: false,
    precoSemIvaMargem: 0,
    produtosSubstitutos: [],
    definirSubstituto: "",
    margemPrecoAutomatico: 0,
    disabledPrecoFields: false,
    codigoRepetido: false,
    personalizar: false,
    tipoProdutoSelected: null,
    mercadoria_disable: false,
    taxa_ivaPrecoSelected: null,
    taxaIvaCompraSelected: null,
    taxaIvaVendaSelected: null,
    disabilita_ivaPreco: false,
    disabilita_ivaVenda: false,
    disabilita_ivaCompra: false,
    tipoPrecoSelecionada: null,
    controleStockSelected: null,
    codigoProduto: null,
    descricaoProduto: null,
    precoComIvaInteiro: null,
    codigoBarraSelected: "",
    descricaoReduzida: "",
    armazemSelected: "",
    motivoIsencao: "",
    margemPreco: "",
    precoSemIva: null,
    precoComIva: "",
    isServicoSelected: false,
    disabledStocksFields: true,
    predifinido: false,
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: "Nº do Bi",
    valorIva: "0",
    validg: true,
    valid1: false,
    valid: false,
    menu: false,
    menubi: false,
    ano_actual: ls.get("anolectivo"),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    imageData: "",
    turmasAll: [],
    servico: "",
    mascara: "#########-AA-###",
    turmasFiltered: [],
    municipiosAll: [],
    cor: "",
    armazem: [],
    taxa_iva: [],
    familiaProduto: [],
    mercadorias: [],
    tipoProdutos: [],
    descricao_isencao_ivaprecoFiltered: [],
    descricao_isencao_compraFiltered: [],
    descricao_isencao_ivaFiltered: [],
    descricao_isencao_iva: [],
    municipiosFiltered: [],
    mercadoriasFiltered: [],
    precosExtensao: [],
    tabelas_preco: [],
    produtoSubstitutoModel: [],
    model: [],
    cursos: [],
    classes: [],
    classesFiltered: [],
    emolumentos: [],
    searchInDb: "",
    classeSelected: null,
    cursoSelected: null,
    stockMinimo: null,
    stockMaximo: null,
    unidadeSelecionada: null,
    search: null,
    showFieldPreco: true,
    disableMargem: true,
    estudantes: [],
    servicos: [],
    dialogGrupo: false,
    valid2: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet

    y: "top",
    text: "mensagem nao setada.",
    controleStock: [
      { id: 1, descricao: "Não" },
      { id: 2, descricao: "Sim" },
    ],
    DefinirPrecoVenda: [
      { id: 1, descricao: "Não" },
      { id: 2, descricao: "Sim" },
    ],
    especificacao: [
      { id: 1, descricao: "Venda Normal" },
      { id: 2, descricao: "Oferta" },
    ],
    Unidades: [
      { id: 1, descricao: "Unidade" },
      { id: 2, descricao: "Kg" },
    ],
    TipoPrecoVenda: [
      { id: 1, descricao: "Manual" },
      { id: 2, descricao: "Automático" },
    ],
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    ruleEmpty: [],
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 100 || "O máximo número de carácters atigidos",

      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],

    rulePrecoVenda: [
      (value) => {
        const valorInteiro = utilitarios.MoneyValueToInteger(value);
        return valorInteiro >= 0 || "O Preço de venda não deve ser negativo.";
      },
    ],
    ruleBI: [
      (value) => value.length === 16 || "Minimo de caracteres exigido( 16 ).",
    ],
    ruleNumber: [
      (value) => !!value || "campo obrigatório.",
      (value) => {
        const pattern = /^[0-9]*$/;
        return pattern.test(value) || "O valor deve ser numerico.";
      },
    ],
    ruleNumberNObrigatorio: [
      (value) => {
        const pattern = /^[0-9]+([,.][0-9]+)?$/g;
        return pattern.test(value) || "O valor deve ser numerico.";
      },
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      (value) => value.length <= 50 || "O máximo número de carácters atigidos",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    headers: [
      {
        text: "Preço descrição",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Margem", value: "calories" },
      { text: "Preço sem IVA", value: "fat" },
      { text: "IVA", value: "carbs" },
      { text: "Modo de isenção", value: "protein" },
      { text: "Preço com IVA", value: "iron" },
      { text: "Stock Mínimo", value: "stock_min" },
      { text: "Stock Máximo", value: "stock_max" },
      { text: "Predifinido", value: "iron" },
    ],
    headersPreco: [
      {
        text: "Preço descrição",
        align: "start",
        sortable: false,
        value: "descricaoPreco",
      },
      { text: "Margem", value: "margem" },
      { text: "Preço sem IVA", value: "editedItem.precoVenda" },
      { text: "IVA", value: "iva" },
      { text: "Modo de isenção", value: "editedItem.isencao" },
      { text: "Preço com IVA", value: "precoComIva" },
      { text: "Stock Mínimo", value: "stock_min" },
      { text: "Stock Máximo", value: "stock_max" },
      { text: "Predifinido", value: "predifinido" },
    ],
    msg: "",
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editeItemGrupo: {
      codigo: "",
      descricao: "",
      pkGrupo: 0,
    },
    produtoInfo: null,
    editedItem: {
      classe: "",
      classe_id: 0,
      codigoBarra: "",
      curso: "",
      curso_id: "",
      emolumento: "",
      entrada_stk: "",
      isencao: "",
      iva: 0,
      pkProduto: 0,
      precoSemIva: 0,
      precoVenda: 0,
      precoVendaDefinido: 0,
      produto: "",
      stock_max: "",
      stock_min: "",
      tipoProduto: 0,
      mercadoria: 0,
      armazem: "",
      descricaoReduzida: "",
      especificacaoProduto: null,
      familia: null,
      controleStock: null,
      stock_min: null,
      stock_max: null,
      unidade: null,
      calculoPrecoVenda: null,
      margem: "",
      descricaoPreco: "",
      precoComIvaNoite: null,
      precoComIvaTarde: null,
      precoPorPeriodo: null,
      precoSemIvaNoite: null,
      precoSemIvaTarde: null,
      idEmolumento: null
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Inser novo Estudante" : "Editar dados de Estudante";
    },
    loggedUserName() {
      return ls.get("nomeUsuario");
    },
    idclasse() {
      return this.$store.state.idclasse;
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format("dddd, MMMM Do YYYY") : "";
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, "dddd, MMMM Do YYYY") : "";
    },
    textMessage() {
      return this.$store.state.textMessage;
    },
    classMessage() {
      return this.$store.state.classMessage;
    },
    hasMessage() {
      return this.$store.state.hasMessage;
    },

    ListaActividades() {
      return ls.get("lista_actividades");
    },

    returnImagem() {
      return this.imageData;
    },

    regime_id() {
      return ls.get("regime");
    },

    regime() {
      return ls.get("regime_descricao");
    },

    id_negocio() {
      return ls.get("id_negocio");
    },
    negocio() {
      return ls.get("negocio");
    },
    isEscola() {
      return this.negocio === "Escola";
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    estudantes() {
      this.isLoading = false;
      this.$store.state.isloading = false;
    },
    dialog(val) {
      val || this.close();
    },
    model(val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop());
      }
    },

    tab(val) {
      console.log(val);
    },
  },

  beforeCreate() {
    if (!this.$store.state.produto) {
      this.$router.push('/consultar-emolumentos')
    }
  },

  created() {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeTipoProdutos();
    this.initializeMercadoria();
    this.initializeArmazem();
    this.initializeFamiliaProduto();
    this.initializeTaxaIva();
    this.initializeIsencaoIva();
    this.initializePrecosDescricao();
    this.editedItem.unidade = this.Unidades[0];
    this.editedItem.calculoPrecoVenda = this.TipoPrecoVenda[0];
    this.editedItem.precoVendaDefinido = this.DefinirPrecoVenda[1];
    if (this.isEscola) {
      this.initializeCursos();
      //this.initializeClasses()
      this.initializeEmolumentos();
      this.emolumentoSelecionados(); // atribuição do objecto selecionado na pagina de listagem de emolumento - para a varivável editedItem
    };
    this.SelecionaEmolumento()
    this.SelecionaTipoServico()
    this.SelecionaIvaPreco()
  },

  methods: {
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },

    SelecionaDefinirPrecoPeriodo() {
      if (this.definirPrecoPeriodoSelected === 1) {
        this.isPrecoDiferente = false;
        this.isPrecoUnico = true;
      } else if (this.definirPrecoPeriodoSelected === 2) {
        this.isPrecoUnico = false;
        this.isPrecoDiferente = true;
      }
    },

    ObterPrecoDescricaoManha() {
      let result = utilitarios.MoneyValueToInteger(this.precoManha)
      if (result <= 0) {
        this.precoManhaDescricao = ''
        this.precoManha = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoManhaDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoManha), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    ObterPrecoDescricaoTarde() {
      let result = utilitarios.MoneyValueToInteger(this.precoTarde)
      if (result <= 0) {
        this.precoTardeDescricao = ''
        this.precoTarde = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoTardeDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoTarde), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    ObterPrecoDescricaoNoite() {
      let result = utilitarios.MoneyValueToInteger(this.precoNoite)
      if (result <= 0) {
        this.precoNoiteDescricao = ''
        this.precoNoite = ''
      } else {
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.precoNoiteDescricao = valor + ' Kwanza(s)'
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoNoite), this.taxa_ivaPrecoSelected)
          this.valorIva = iva
        }
      }
    },

    async emolumentoSelecionados() {
      this.editedItem = Object.assign(this.editedItem, this.$store.state.produto);
      this.editedItem.precoVenda = utilitarios.IntegerToMoneyValue(this.editedItem.precoVenda)
      this.definirPrecoPeriodoSelected = this.editedItem.precoPorPeriodo;
      this.SelecionaDefinirPrecoPeriodo();
      if (this.definirPrecoPeriodoSelected == 1) {
        this.precoSemIva = this.editedItem.precoSemIva;
        this.ObterPrecoDescricao()        
      } else if (this.definirPrecoPeriodoSelected == 2) {
        this.precoManha = this.editedItem.precoSemIva;
        this.precoTarde = this.editedItem.precoSemIvaTarde;
        this.precoNoite = this.editedItem.precoSemIvaNoite;
        this.ObterPrecoDescricaoManha();
        this.ObterPrecoDescricaoTarde();
        this.ObterPrecoDescricaoNoite();
      }

      console.log(this.editedItem, ' EDITED ITEM');
    },

    async initializeEmolumentos() {
      try {
        this.isLoading = true;
        this.emolumentos = await axios.get("/emolumentosFindAll").then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axiosFinancas.get("/cursoInstituicaoFindAllIntegracao").then((res) => res.data);
        this.editedItem.curso = await axiosFinancas.get("/cursoInstituicaoFindAllIntegracao").then((res) => res.data.filter(d => d.descricao === this.editedItem.curso)[0])
        this.loadclasse()
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios.get("/anoacademicoFindAll").then((res) => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    loadclasse() {
      for (let index = 1; index <= parseInt(this.editedItem.curso.numero_anos_academicos); index++) {
        this.classesFiltered.push({ id: index, descricao: index + "º ano" });
      }
      this.classesFiltered.unshift({
        pkAnoacademico: -1,
        descricao: "Todas os anos",
      });

      this.editedItem.classe = this.classesFiltered.filter(c => c.id === this.editedItem.classe_id)[0]
    },

    async initializeTipoProdutos() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.tipoProdutos = await axios.get("/tipoProdutoFindall").then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // combo qua depende de outra combo
    async initializeMercadoria() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.mercadorias = await axios.get("/mercadoriaFindall").then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // comb

    SelecionaEmolumento() {
      if (this.editedItem.emolumento.descricao === undefined) {
        this.descricaoProduto = this.editedItem.emolumento;
      } else {
        this.editedItem.descricaoReduzida = this.editedItem.emolumento.descricao;
        this.descricaoProduto = this.editedItem.emolumento.descricao;
      }
      this.SelecionaIvaPreco()
    },

    async CarregaProdutos() {
      try {
        //   let  payload =""
        this.overlay = true;
        this.produtosSubstitutos = await axios.get("/produtosFindall-substituto").then((res) => res.data);
        this.overlay = false;
      } catch (error) {
        this.overlay = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initializeArmazem() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.armazem = await axios.get("/armazemFindall").then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // comb
    async initializeFamiliaProduto() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.familiaProduto = await axios.get("/FamiliaProdutoFindall").then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // comb

    async initializeTaxaIva() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.taxa_iva = await axios.get("/TaxaIvaFindall").then((res) => res.data);

        // this.editedItem.iva = this.taxa_iva[0]
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // comb
    async initializeIsencaoIva() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.descricao_isencao_iva = await axios.get("/IsencaoIvaFindall").then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // comb
    async VerificaCodigoExistente() {
      try {
        //   let  payload =""
        this.isLoading = true;
        let result = await axios.get("/verificaCodigoBarra/" + this.editedItem.codigoBarra).then((res) => res.data);
        if (result.length) {
          this.codigoRepetido = true;
          Swal.fire("Código de barra já existente.", "", "warning");
        } else {
          this.codigoRepetido = false;
        }
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initializePrecosDescricao() {
      try {
        //   let  payload =""
        this.isLoading = true;
        this.precosExtensao = await axios.get("/precosExtensaoFindall").then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // comb

    async SaveGrupo() {
      if (this.$refs.formg.validate()) {
        let params = {
          pkFamilia: 0,
          descricao: this.editeItemGrupo.descricao,
          codigo: this.editeItemGrupo.codigo,
        };

        try {
          //   let  payload =""
          this.isLoading = true;
          let result = await axios.post("/FamiliaInsertUpdate", params).then((res) => res.data);
          if (result.affectedRows >= 0) {
            this.initializeFamiliaProduto().then(() => {
              this.editedItem.familia =
                this.familiaProduto[this.familiaProduto.length - 1];
              this.dialogGrupo = false;
              this.editeItemGrupo.codigo = "";
              this.editeItemGrupo.descricao = "";
            });
          }
        } catch (error) {
          this.isLoading = false;

          this.text = error;
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
    },

    Continuar() {
      if (this.$refs.form.validate()) {
        this.tab = 1;
      }
    },

    Continuar2() {
      if (this.$refs.form1.validate()) {
        this.tab = 2;
      }
    },

    TabIndexToZero(id) { },

    SelecionaUnidade() { },

    SelecionaIvaVenda() {
      if (this.taxaIvaVendaSelected !== null) {
        if (this.taxaIvaVendaSelected === 0) {
          this.descricao_isencao_ivaFiltered = this.descricao_isencao_iva;
          this.disabilita_ivaVenda = false;
        } else {
          this.disabilita_ivaVenda = true;
          this.descricao_isencao_ivaFiltered = [];
        }
      }
    },

    SelecionaControleStock() {
      if (this.editedItem.controleStock === 1) {
        this.disabledStocksFields = true;
      } else {
        this.disabledStocksFields = false;
      }
    },

    SelecionaDefinirPrecoVenda() {
      if (this.editedItem.precoVendaDefinido === 1) {
        this.disabledPrecoFields = true;
        this.showFieldPreco = false;
        // Faz o reset da combobox de seleção do calculo do preço
        this.disableMargem = true;
        this.editedItem.calculoPrecoVenda = this.TipoPrecoVenda[0];
        // Faz o reset da combobox --- Fim
        this.LimpaCamposPreco();
      } else if (this.editedItem.precoVendaDefinido === 2) {
        this.disabledPrecoFields = false;
        this.showFieldPreco = true;
      }
    },

    showDialogGrupo() {
      this.editeItemGrupo.codigo = this.descricaoProduto;
      this.dialogGrupo = true;
    },

    ObterPrecoDescricao() {
      let result = utilitarios.MoneyValueToInteger(this.precoSemIva);
      if (result <= 0) {
        this.valorDescricao = "";
        this.precoComIva = "";
      } else {
        let valor = numero.porExtenso(result);
        valor = valor.includes("um mil") ? valor.replace("um mil", "mil") : valor;
        this.valorDescricao = valor + " Kwanza(s)";
        if (this.regime_id !== 1) {
          this.CalculaPreComIva(this.editedItem.iva / 100);
          let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoSemIva), this.editedItem.iva);
          this.valorIva = iva;
        }
      }
    },

    SelecionaIvaCompra() {
      if (this.taxaIvaCompraSelected !== null) {
        if (this.taxaIvaCompraSelected === 0) {
          this.descricao_isencao_compraFiltered = this.descricao_isencao_iva;
          this.disabilita_ivaCompra = false;
        } else {
          this.disabilita_ivaCompra = true;
          this.descricao_isencao_compraFiltered = [];
        }
      }
    },

    SelecionaIvaPreco() {
      if (this.editedItem.iva !== null) {
        if (this.editedItem.iva === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva;
          this.disabilita_ivaPreco = false;
        } else {
          this.disabilita_ivaPreco = true;
          this.descricao_isencao_ivaprecoFiltered = [];
        }

        this.CalculaPreComIva(this.editedItem.iva / 100);
        let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.editedItem.precoVenda), this.editedItem.iva);
        this.valorIva = iva;
      }
    },

    SelecionaEspecProduto() {
      if (this.editedItem.especificacaoProduto.id === 0) {
        this.precoComIvaInteiro = 0;
        this.editedItem.precoVenda = 0;
        this.editedItem.margem = 0;
        this.editedItem.iva = 0;
        this.editedItem.descricaoPreco = "Zero Kwanza";
      }
    },

    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log("elso foraaa");
      }
    },

    reset() {
      this.$refs.form.reset();
      this.Limpar();
    },

    reset2() {
      this.$refs.form.resetValidation();
      this.LimparSelected();
    },

    resetValidation() {
      this.$refs.form.reset();
    },

    SelecionaTipoServico() {
      if (this.editedItem.tipoProduto !== null) {
        this.mercadoriasFiltered = this.mercadorias.filter((f) => f.fk_tipoProduto === this.editedItem.tipoProduto);
        if (this.editedItem.tipoProduto === 2) {
          // Selecionou um serviço
          this.isServicoSelected = true;
          this.reset2();
          this.editedItem.armazem = 3; // set os valores default
          this.editedItem.mercadoria = 7; // set os valores default
          this.editedItem.familia = 5; // set os valores default
        } else this.isServicoSelected = false;
      }
    },

    savePreco() {
      if (this.$refs.form.validate()) {
        let params = {
          descricaoPreco: this.editedItem.descricaoPreco,
          margem: this.editedItem.margem,
          precoSemIva: this.editedItem.precoVenda,
          iva: this.editedItem.iva,
          motivoIsencao: this.editedItem.isencao,
          predifinido: this.predifinido,
          precoComIva: this.precoComIva,
        };

        this.tabelas_preco.push(params);
        this.dialog = false;
      }
    },

    CalculoPrecoVenda() {
      if (this.editedItem.calculoPrecoVenda === 1) {
        this.disableMargem = true;
        this.Precoautomatico = false;
      } else {
        SelecionaTipoServico
        this.disableMargem = false;
        this.Precoautomatico = true;
      }
    },

    async saveProduto() {
      if (this.$refs.form1.validate() && this.$refs.form.validate() && this.$refs.form2.validate()) {
        // Definição das variaveis
        this.overlay = true;

        if (this.editedItem.iva !== 0) {
          this.editedItem.isencao = "";
        }

        if (this.editedItem.tipoProduto === 2) {
          this.editedItem.mercadoria = '';
          this.editedItem.codigoBarra = '';
          this.editedItem.armazem = '';
          this.editedItem.especificacaoProduto = ''
        }

        let precoVenda = this.Precoautomatico ? this.precoSemIvaMargem : this.precoSemIva ? this.precoSemIva : utilitarios.MoneyValueToInteger(this.precoManha)

        if (this.definirPrecoPeriodoSelected === 1) {
          this.precoManha = precoVenda;
          this.precoTarde = precoVenda;
          this.precoNoite = precoVenda;
          this.precoComIva = precoVenda;
          this.precoNoiteDescricao = this.valorDescricao;
          this.precoTardeDescricao = this.valorDescricao;
          this.precoManhaDescricao = this.valorDescricao;
        } else {
          this.precoComIva = utilitarios.MoneyValueToInteger(this.precoManha)
        }

        let params = {
          descricao: this.editedItem.produto,
          descricaoReduzida: this.editedItem.descricaoReduzida,
          codigoBarra: this.editedItem.codigoBarra,
          armazem: this.editedItem.armazem,
          tipoProduto: this.editedItem.tipoProduto,
          mercadoria: this.editedItem.mercadoria,
          familia: this.isEscola ? null : this.editedItem.familia.pkFamiliaProduto !== undefined ? this.editedItem.familia.pkFamiliaProduto : this.editedItem.familia,
          isencao: this.editedItem.isencao,
          pkProduto: this.editedItem.pkProduto,
          especificacaoProduto: this.editedItem.especificacaoProduto,
          stockMinimo: this.editedItem.controleStock === 1 || this.editedItem.controleStock === null ? null : this.editedItem.stock_min,
          stockMaximo: this.editedItem.controleStock === 1 || this.editedItem.controleStock === null ? null : this.editedItem.stock_max,
          unidade: this.editedItem.unidade,
          controleStock: this.editedItem.controleStock,
          substituto: this.produtoSubstitutoModel.length ? this.produtoSubstitutoModel : "",
          curso: {descricao: this.editedItem.curso, idCurso: this.editedItem.curso_id},
          classe: {descricao: this.editedItem.classe, id: this.editedItem.classe_id},
          classes: this.classesFiltered,
          idEmolumento: this.editedItem.idEmolumento,
          precoComIva: utilitarios.MoneyValueToInteger(this.precoComIva),
          precoComIvaTarde: utilitarios.MoneyValueToInteger(this.precoTarde),
          precoComIvaNoite: utilitarios.MoneyValueToInteger(this.precoNoite),
          precoSemIva: utilitarios.MoneyValueToInteger(this.precoComIva),
          precoSemIvaTarde: (this.DefinirPrecoVendaSelected === 1) ? null : ((this.precoTarde !== 0) ? utilitarios.MoneyValueToInteger(this.precoTarde) : 0),
          precoSemIvaNoite: (this.DefinirPrecoVendaSelected === 1) ? null : ((this.precoNoite !== 0) ? utilitarios.MoneyValueToInteger(this.precoNoite) : 0),
          margem: this.Precoautomatico ? this.margemPrecoAutomatico : this.editedItem.margem,
          iva: this.editedItem.iva,
          descricaoPreco: this.valorDescricao,
          precoVendaDefinido: this.editedItem.precoVendaDefinido,
          CalculoPrecoVenda: this.editedItem.calculoPrecoVenda,
          precoPorPeriodo: this.definirPrecoPeriodoSelected
        };

        try {
          //   let  payload =""
          this.isLoading = true;
          let msg = await axios.post("/produtoUpdate", params).then((res) => res.data);
          if (msg.affectedRows !== undefined) {
            if (msg.affectedRows >= 1) {
              Swal.fire(this.negocio === "Escola" ? "Emolumento editado com sucesso" : "Produto editado com sucesso", "", "success");
              //this.tab = 0;
              this.overlay = false;
              this.reset();
              this.$router.push('/consultar-emolumentos')
            } else {
              Swal.fire("Ocorreu um erro ao tentar editar o Produto!", "", "warning");
              this.tab = 0;
            }
          } else if (msg.sqlMessage !== undefined) {
            Swal.fire("Ocorreu um erro ao tentar editar o Produto!", "", "warning");
            this.tab = 0;
          }
        } catch (error) {
          this.isLoading = false;
          this.text = error;
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgError",
            timeout: 3000,
          });
        } finally {
          this.overlay = false;
        }
      }
    },

    Limpar() {
      this.descricaoProduto = "";
      this.editedItem.descricaoReduzida = "";
      this.editedItem.armazem = "";
      this.tipoProdutoSelected = "";
      this.editedItem.mercadoria = "";
      this.editedItem.familia = "";
      this.tabelas_preco = [];
      this.produtoSubstitutoModel = [];
    },

    LimparSelected() {
      this.editedItem.armazem = "";
      this.editedItem.mercadoria = "";
      this.editedItem.familia = "";
      this.tabelas_preco = [];
      this.produtoSubstitutoModel = [];
    },

    LimpaCamposPreco() {
      this.precoComIva = "";
      this.precoComIvaInteiro = "";
      this.precoSemIvaMargem = "";
      this.editedItem.precoVenda = "";
      this.editedItem.descricaoPreco = "";
      this.margemPrecoAutomatico = "";
      this.editedItem.margem = "";
      this.editedItem.isencao = "";
      this.editedItem.iva = "";
      this.margem = "";
    },

    CalculaPreComIva(valor) {
      let Preco = !this.disableMargem ? this.precoSemIvaMargem : this.editedItem.precoVenda;
      let valorIva = (Preco === 0 ? 0 : utilitarios.MoneyValueToInteger(Preco)) * valor;
      let valorFinal = (Preco === 0 ? 0 : utilitarios.MoneyValueToInteger(Preco)) + valorIva;
      this.precoComIva = valorFinal;
      this.precoComIva = this.ObterValorFormatado(valorFinal);
      this.precoComIvaInteiro = valorFinal;
    },

    CalculoPrecoVendaAutomatico() {
      let CustoDouble = utilitarios.MoneyValueToInteger(this.custoCompra);
      let lucro = (CustoDouble * this.margemPrecoAutomatico) / 100;
      let PrecoVendaCalculado = CustoDouble + lucro;
      this.precoSemIvaMargem = utilitarios.IntegerToMoneyValue(PrecoVendaCalculado);
      this.PrecoDescricao(this.precoSemIvaMargem);
    },

    PrecoDescricao(preco) {
      let result = utilitarios.MoneyValueToInteger(preco);
      let valor = numero.porExtenso(result);
      valor = valor.includes("um mil") ? valor.replace("um mil", "mil") : valor;
      this.editedItem.descricaoPreco = valor + " Kwanza(s)";
    },

    ObterValorFormatado(valor) {
      let formated = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "AOA",
      }).format(valor);
      return formated.toString().replace("AOA", "");
    },
  },
};
</script>

<style scoped>
.btn_space {
  margin-bottom: 5px;
}

.btn_add_align {
  margin-top: 10px;
}

.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 20px;
}

img.preview {
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>
